import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';
import { useFrame, useLoader } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { Group } from 'three';
import { position, rotation, scale } from './FaceRecognition';
import { updateOccluderMaterial, updateGlassesMaterial } from "./OccluderMaterial";

export const Glasses = ({ url }: { url: string }) => {
  const { scene: glassesGltf } = useGLTF(url);
  const { scene: occluderGltf } = useGLTF("/assets/face_occluder.glb");
  const groupRef = useRef<Group>(null);
  const hdrTexture = useLoader(RGBELoader, '/assets/images/hall_1k.hdr');

  useEffect(() => {
    if (hdrTexture) {
      hdrTexture.mapping = THREE.EquirectangularReflectionMapping;
    }
    if (occluderGltf) {
      updateOccluderMaterial(occluderGltf, 0);
    }
    if (glassesGltf) {
      updateGlassesMaterial(glassesGltf, hdrTexture);
    }
  }, [occluderGltf, glassesGltf, hdrTexture]);

  useFrame(() => {
    if (groupRef.current != null && rotation) {
      groupRef.current.position.set(position.x, position.y, position.z);
      groupRef.current.rotation.set(rotation.x, rotation.y, rotation.z);
      groupRef.current.scale.set(scale.x, scale.y, scale.z);
    }
  });


  return (
    <>
      <group ref={groupRef} >
        <primitive object={glassesGltf} position={[0, 1.7, 3]} scale={[100, 100, 100]} renderOrder={2} />
        <primitive object={occluderGltf} position={[0, 1.7, 3]} scale={[100, 100, 100]} renderOrder={1} />
      </group>
    </>
  );
};
